export const RespuestaAdapter = (respuesta) => ({
    codigo: respuesta.codigo,
    datos: respuesta.datos,
    data: respuesta.data,
    error: respuesta.error,
    info: respuesta.info,
    login: respuesta.login,
    mensaje: respuesta.mensaje,
    success: respuesta.success,
    total: respuesta.total,
});
